'use strict';

var $explorerBar = $('.js-explorer-bar'),
    headerOffset,
    durationTiming;

if (!$explorerBar.length) return;

durationTiming = 500;
headerOffset =  $('.js-site-header').outerHeight();


$explorerBar.on('click.explorer', function(ev){
  ev.preventDefault();

  $explorerBar.velocity('scroll', {duration: durationTiming, offset: -headerOffset});

});